import React from 'react';
import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import {
  VersionSelectCombobox,
  VersionSelectContextMenu,
  VersionSelectNextVersion,
  VersionSelectPreviousVersion,
} from './components';
import { VersionSelectContext } from './context';

type VersionSelectPropsType = React.PropsWithChildren & {
  selectedVersion?: string;
};

const VersionSelectRoot: React.FC<VersionSelectPropsType> = ({
  children,
  selectedVersion,
}) => {
  const { t } = useTranslation();
  return (
    <VersionSelectContext.Provider value={{ selectedVersion }}>
      <Group role="group" aria-label={t('VERSION_SELECT.LABEL')} gap="xs">
        {children}
      </Group>
    </VersionSelectContext.Provider>
  );
};

export const VersionSelect = Object.assign(VersionSelectRoot, {
  Combobox: VersionSelectCombobox,
  PreviousVersion: VersionSelectPreviousVersion,
  NextVersion: VersionSelectNextVersion,
  ContextMenu: VersionSelectContextMenu,
});
